module.exports = __webpack_public_path__ + "static/media/entidad-financiera.63b51d5b.png";